"use client"

import Image from "next/image"
import type { Book } from "@/schema"

import { useFetchCurrentUser } from "@/hooks/api/users"
import { cn } from "@/components/_ui/utils"

interface BookIconProps {
  book?: Pick<Book, "id" | "initials" | "icon_image_url" | "name"> | null
  bookId?: string | number | null
  initials?: string | null
  name?: string | null
  iconImageUrl?: string | null
  className?: string
  textClassName?: string
}

export function BookIcon({ book, bookId, initials, name, iconImageUrl, className, textClassName }: BookIconProps) {
  const { data: currentUser } = useFetchCurrentUser()
  const resolvedBook = book ?? currentUser?.books.find((candidate) => candidate.id === String(bookId))
  const resolvedIconImageUrl = iconImageUrl ?? resolvedBook?.icon_image_url
  const fallbackInitials = initials ?? resolvedBook?.initials

  return (
    <span
      className={cn("relative flex shrink-0 items-center justify-center overflow-hidden", className)}
      aria-label={name ?? resolvedBook?.name ?? undefined}
    >
      {resolvedIconImageUrl ? (
        <Image src={resolvedIconImageUrl} alt="" fill sizes="40px" className="object-cover" unoptimized />
      ) : (
        <span className={textClassName}>{fallbackInitials}</span>
      )}
    </span>
  )
}
